/** @jsxImportSource theme-ui */
import { Container, Heading, Box, Flex } from 'theme-ui';
import EditIncentive from '@/containers/incentives/EditIncentive';

const IncentivePage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Edit Incentive
            </Heading>
            <EditIncentive />
        </Container>
    );
};

export default IncentivePage;
